<template>
  <div>
    <b-card no-body class="mt-6 pb-10 px-10">
      <ATestimonialpopup
        :isActive="isAddtestActive"
        :selectaddTesimonial="selectaddTesimonial"
        @close="handleAddTestimonial"
      />
      <EditTestimonialpopup
        :isActive="isEditTestActive"
        :selectEditTesimonial="selectEditTesimonial"
        @close="handleEditTestimonial"
      />
      <ViewPopup
        :isActive="isViewtestActive"
        :selectviewTesimonial="selectviewTesimonial"
        @close="handleViewTestimonial"
      />
      <div class="flex justify-between items-center py-10">
        <div>
          <h2 class="text-2xl font-semibold">Testimonial</h2>
        </div>

        <div @click="handleAddTestimonial">
          <base-button outline class="px-6 py-1 mx-1" type="primary">
            <span class="btn-inner--text flex justify-between items-center"
              ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
              Testimonial</span
            >
          </base-button>
        </div>
      </div>
      <div class="flex gap-4">
        <div class="w-full">
          <b-input-group class="">
            <b-form-input
              class="border-none shadow-lg"
              type="text"
              v-model="search"
              placeholder="Enter Search...."
            ></b-form-input>

            <b-input-group-append>
              <b-button
                variant="white"
                class="flex items-center shadow-lg"
                aria-label="search"
                @click="getAllTestimonial"
              >
                <feather-icon
                  class="cursor-pointer mr-2"
                  icon="SearchIcon"
                  svgClasses="w-4 h-4"
                ></feather-icon>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <!-- <div class="w-1/4">
          <b-form-select
            v-model="selected"
            :options="options"
            placeholder="filter"
          ></b-form-select>
        </div> -->
      </div>
      <el-table
        class="table-responsive table-flush mt-4"
        header-row-class-name="thead-light table-th-color table-textcenter"
        :data="tableData"
        border
      >
        <el-table-column label="Sr. no" prop="srno" width="80px" sortable>
        </el-table-column>
        <el-table-column label="Image" prop="image" sortable>
          <template slot-scope="scope">
            <img :src="`${$imageURL}/${scope.row.image}`" :alt="image" />
          </template>
        </el-table-column>
        <el-table-column label="Name" prop="name" sortable> </el-table-column>
        <el-table-column label="Profession" prop="profession" sortable>
        </el-table-column>
        <el-table-column label="Description" prop="description" sortable>
        </el-table-column>
        <el-table-column label="Status" prop="status" sortable>
          <template slot-scope="scope">
            <div v-if="scope.row.status === 'Accept'">Accepted</div>
            <div v-if="scope.row.status === 'Reject'">Rejected</div>
            <div v-if="scope.row.status === 'Pending'">Pending</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Actions"
          min-width="80px"
          class-name="text-center"
        >
          <template slot-scope="scope">
            <div class="flex justify-center items-center">
              <feather-icon
                icon="CheckIcon"
                svgClasses="w-6 text-green-500 cursor-pointer"
                class=""
                v-if="scope.row.status === 'Pending'"
                @click="handleEdit(scope.row, 'Accept')"
              ></feather-icon>
              <feather-icon
                icon="XIcon"
                svgClasses="w-6 text-red-600 cursor-pointer"
                class="ml-2"
                v-if="scope.row.status === 'Pending'"
                @click="handleEdit(scope.row, 'Reject')"
              ></feather-icon>
              <div class="flex" @click="handleViewTestimonial(true, scope.row)">
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 text-red-600 cursor-pointer"
                  class="ml-2"
                ></feather-icon>
              </div>
              <!-- <div class="flex">
                <feather-icon
                  icon="Edit2Icon"
                  svgClasses="w-4 text-blue-600 cursor-pointer"
                  class="ml-2"
                ></feather-icon>
              </div> -->
              <div
                class="flex"
                v-if="scope.row.isAdmin"
                @click="handleEditTestimonial(true, scope.row)"
              >
                <feather-icon
                  icon="Edit2Icon"
                  svgClasses="w-4 text-blue-600 cursor-pointer"
                  class="ml-2"
                ></feather-icon>
              </div>
              <div class="flex">
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-5 text-red-600 cursor-pointer"
                  class="ml-2"
                  @click="handleDelete(scope.row)"
                ></feather-icon>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
// import Data from "./Data";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";
import ATestimonialpopup from "./components/ATestimonialpopup.vue";
import EditTestimonialpopup from "./components/EditTestimonialpopup.vue";
import ViewPopup from "./components/ViewPopup.vue";
import { mapState } from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    ATestimonialpopup,
    EditTestimonialpopup,
    ViewPopup,
  },
  data() {
    return {
      isAddtestActive: false,
      isEditTestActive: false,
      isViewtestActive: false,
      selectaddTesimonial: {},
      selectEditTesimonial: {},
      selectviewTesimonial: {},

      // currentPage: 1,
      // selected: "",
      // perPage: 8,
      options: [
        {
          value: "trewyery",
        },
        {
          value: "1",
        },
        {
          value: "1",
        },
      ],
      tableData: [],
      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      name: "",
      description: "",
      isHidden: false,
      profession: "",
      relate: "",
      suggestion: "",
      status: "",
      image: null,
      testimonialId: "",
    };
  },
  watch: {
    async currentPage() {
      await this.getAllTestimonial();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getAllTestimonial();
      }, 500),
    },
    isAddtestActive(val) {
      if (!val) {
        this.getAllTestimonial();
      }
    },
    isEditTestActive(val) {
      if (!val) {
        this.getAllTestimonial();
      }
    },
  },
  computed: {
    ...mapState("testimonial", {
      testimonial: "testimonial",
    }),
  },
  methods: {
    handleAddTestimonial(val = false, item = {}) {
      this.isAddtestActive = val;
      this.selectaddTesimonial = item;
    },
    handleEditTestimonial(val = false, item = {}) {
      // console.log(val);
      this.isEditTestActive = val;
      this.selectEditTesimonial = item;
    },
    handleViewTestimonial(val = false, item = {}) {
      this.isViewtestActive = val;
      this.selectviewTesimonial = item;
    },
    // async function() {
    //   this.$store.dispatch("services/getallhomebanner");
    // },
    handleView(row) {
      this.testimonialId = row._id;
      // console.log(this.testimonialId);
    },

    async handleEdit(row, status) {
      const payload = new FormData();
      payload.append("status", status);
      payload.append("testimonialId", row._id);
      let loader;
      try {
        loader = this.$loading();
        const updateStatus = await this.$store.dispatch(
          "testimonial/updateTestimonial",
          payload
        );
        loader.close();

        // console.log(updateStatus);
        this.getAllTestimonial();
      } catch (error) {
        loader.close();
        console.log(e);
      }
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(row) {
      let loader;
      let payload = {
        testimonialId: row._id,
      };
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "testimonial/deleteTestimonial",
          payload
        );
        loader.close();
        if (data.code === 200) {
          await this.$swal({
            text: "Testimonial have been successfully deleted",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.getAllTestimonial();
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
    async getAllTestimonial() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });
      let loader;
      try {
        // console.log(payload);
        loader = this.$loading();
        const allTestimonial = await this.$store.dispatch(
          "testimonial/getAllTestimonial",
          payload
        );

        // console.log(allTestimonial);
        loader.close();

        this.totalRows = this.testimonial.totalCount;
        let testimonialData = this.testimonial.result;
        // console.log(testimonialData);

        const testimonials = testimonialData.map((testimonial, index) => {
          let image =
            "caregiversaathi/testimonialImage/testimonialImage-NaKBE_DSc1jEp-s3GXor2-1676447817";
          if (testimonial && testimonial.hasOwnProperty("image")) {
            image = testimonial.image;
          }
          let suggestion = "No Suggestion";
          if (testimonial && testimonial.hasOwnProperty("suggestion")) {
            suggestion = testimonial.suggestion;
          }

          return {
            srno: index + 1 + curPage * this.perPage,
            name: testimonial.name,
            description: testimonial.description,
            isHidden: testimonial.isHidden,
            profession: testimonial.profession,
            relate: testimonial.relate,
            suggestion: suggestion,
            status: testimonial.status,
            image: image,
            isAdmin: testimonial.hasOwnProperty("isAdmin")
              ? testimonial.isAdmin
              : false,
            _id: testimonial._id,
          };
        });
        // console.log(testimonials);
        this.tableData = testimonials;
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
  },
  async mounted() {
    await this.getAllTestimonial();
  },
};
</script>

<style>
.clr606266 {
  color: #606266;
}
</style>
